import axios from 'axios'
import Vue from 'vue'

export default {
  doLogin(credenciales) {
    console.log(credenciales)
    let endpoint = '/login'
    return axios.post(process.env.VUE_APP_API_URL + endpoint, credenciales)
      .catch(err => {
        console.error(err)
        return Promise.resolve({data: {ok: false}})
      })
  },

  doLogout: function () {
    let endpoint = '/logout'
    return axios.post(process.env.VUE_APP_API_URL + endpoint, {})
  },

  checarSesion: async () => {
    let token = await Vue.localForage.$getItem('token')
    if (!token) {
      return Promise.resolve({msg: 'No hay token', ok: false})
    }
    const payload = Vue.$jwt.decode(token)
    let current_time = new Date().getTime() / 1000;
    if (current_time > payload.exp) {
      Vue.localForage.$clearStorage
      return Promise.resolve({msg: 'Token ha expirado', ok: false})
    } else {
      return Promise.resolve({ok: true})
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/login.js